__turbopack_context__.v({
  "actions": "ContactUsSection-module__hv727G__actions",
  "captchaBox": "ContactUsSection-module__hv727G__captchaBox",
  "captchaInner": "ContactUsSection-module__hv727G__captchaInner",
  "captchaItem": "ContactUsSection-module__hv727G__captchaItem",
  "card": "ContactUsSection-module__hv727G__card",
  "cardLabel": "ContactUsSection-module__hv727G__cardLabel",
  "cardText": "ContactUsSection-module__hv727G__cardText",
  "cardValue": "ContactUsSection-module__hv727G__cardValue",
  "contactCard": "ContactUsSection-module__hv727G__contactCard",
  "contactCards": "ContactUsSection-module__hv727G__contactCards",
  "decor": "ContactUsSection-module__hv727G__decor",
  "decorBottomLeft": "ContactUsSection-module__hv727G__decorBottomLeft",
  "decorBottomRight": "ContactUsSection-module__hv727G__decorBottomRight",
  "decorTopLeft": "ContactUsSection-module__hv727G__decorTopLeft",
  "decorTopRight": "ContactUsSection-module__hv727G__decorTopRight",
  "emailCard": "ContactUsSection-module__hv727G__emailCard",
  "emailIcon": "ContactUsSection-module__hv727G__emailIcon",
  "form": "ContactUsSection-module__hv727G__form",
  "formWrap": "ContactUsSection-module__hv727G__formWrap",
  "header": "ContactUsSection-module__hv727G__header",
  "iconCircle": "ContactUsSection-module__hv727G__iconCircle",
  "map": "ContactUsSection-module__hv727G__map",
  "notesItem": "ContactUsSection-module__hv727G__notesItem",
  "optional": "ContactUsSection-module__hv727G__optional",
  "phone": "ContactUsSection-module__hv727G__phone",
  "row": "ContactUsSection-module__hv727G__row",
  "section": "ContactUsSection-module__hv727G__section",
  "socialLink": "ContactUsSection-module__hv727G__socialLink",
  "socialTagline": "ContactUsSection-module__hv727G__socialTagline",
  "socials": "ContactUsSection-module__hv727G__socials",
  "submit": "ContactUsSection-module__hv727G__submit",
  "subtitle": "ContactUsSection-module__hv727G__subtitle",
  "success": "ContactUsSection-module__hv727G__success",
  "title": "ContactUsSection-module__hv727G__title",
  "whatsappCard": "ContactUsSection-module__hv727G__whatsappCard",
  "whatsappIcon": "ContactUsSection-module__hv727G__whatsappIcon",
});
